// import Axios from "../common/axios"
import Axios from "axios"
import { AppState } from '../reducers'

enum Type {
    WAITING = "FETCH_FACILITY_WAITING"
    , COMPLETED = "FETCH_FACILITY_COMPLETED"
    , ERROR = "FETCH_FACILITY_ERROR"
}

interface Action {
    type: Type
    payload: any
}

export const fetch = (tenantId: number) => async (dispatch: (payload: Action) => Action, getState: () => AppState) => {
    const state = getState().facility

    if (state.loading || state.fetched) {
        return
    }

    const uri = `/api/${tenantId}/facility`
    const cache = sessionStorage.getItem(uri)

    if (cache) {
        return dispatch({ type: Type.COMPLETED, payload: { data: JSON.parse(cache) } })
    }

    dispatch({ type: Type.WAITING, payload: {} })

    try {
        const { data, request } = await Axios.get(uri)

        // if (request.responseURL.endsWith("/login")) {
        //     throw new Error("redirected to /login")
        // }

        sessionStorage.setItem(uri, JSON.stringify(data))
        dispatch({ type: Type.COMPLETED, payload: { data } })
    } catch (error) {
        dispatch({ type: Type.ERROR, payload: { error } })
    }
}

export interface FacilityState {
    loading: boolean
    fetched: boolean

    data: any[]
    included: any[]
}

const reducer = (prevState: FacilityState, action: Action): FacilityState => {
    const state = { ...prevState }

    switch (action.type) {
        case Type.WAITING:
            state.loading = true
            break
        case Type.COMPLETED:
            state.loading = false
            state.fetched = true

            const { data, included } = action.payload.data

            state.data = [...data]

            if (included) {
                state.included = [...included]
            }
            break
    }

    return state
}

export default reducer
